import { render, staticRenderFns } from "./TicketRequests.vue?vue&type=template&id=49142b96&scoped=true"
import script from "./TicketRequests.vue?vue&type=script&lang=js"
export * from "./TicketRequests.vue?vue&type=script&lang=js"
import style0 from "./TicketRequests.vue?vue&type=style&index=0&id=49142b96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49142b96",
  null
  
)

export default component.exports